import React, { useEffect, useState } from 'react';
import { client } from '../../client';
import Spinner from '../Spinner';

const RedemptionRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    setLoading(true);
    const query = `*[_type == "redeemRequest" && status == "pending"]{
      _id,
      amount,
      payoutDetails,
      status,
      requestedAt,
      userId->{_id, userName, image, coins}
    } | order(requestedAt desc)`;

    try {
      const data = await client.fetch(query);
      setRequests(data);
    } catch (err) {
      console.error('Failed to fetch requests:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const updateRequestStatus = async (requestId, newStatus) => {
    try {
      await client.patch(requestId).set({ status: newStatus }).commit();

      if (newStatus === 'approved') {
        const request = requests.find(r => r._id === requestId);
        if (request && request.userId) {
          await client.patch(request.userId._id).inc({ coins: -request.amount }).commit();
        }
      }

      alert(`Request ${newStatus === 'approved' ? 'approved and payout processed' : 'rejected'}.`);
      fetchRequests();
    } catch (error) {
      console.error(`Failed to update request status:`, error);
      alert('Failed to update request. Try again.');
    }
  };

  if (loading) return <Spinner message="Loading redemption requests..." />;
  if (requests.length === 0) return <p className="text-center text-gray-500">No pending redemption requests.</p>;

  return (
    <div className="p-6 bg-white dark:bg-gray-800 rounded shadow-md">
      <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-gray-100">Redemption Requests</h2>
      <ul className="space-y-4">
        {requests.map(({ _id, amount, requestedAt, userId, payoutDetails }) => (
          <li key={_id} className="p-4 border border-gray-300 dark:border-gray-700 rounded-lg flex items-center justify-between bg-gray-50 dark:bg-gray-900">
            <div className="flex items-start gap-4">
              <img
                src={userId.image || '/default-profile.png'}
                alt={userId.userName}
                className="w-14 h-14 rounded-full object-cover border"
              />
              <div className="space-y-1">
                <p className="font-semibold text-gray-900 dark:text-white">{userId.userName}</p>
                <p className="text-sm text-gray-700 dark:text-gray-300">Requested <strong>{amount}</strong> coins</p>
                <p className="text-sm text-blue-600 dark:text-blue-400">Payout: {payoutDetails || 'N/A'}</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Remaining after approval: {userId.coins - amount}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-500">{new Date(requestedAt).toLocaleString()}</p>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => updateRequestStatus(_id, 'approved')}
                className="bg-green-600 text-white px-4 py-1 rounded hover:bg-green-700 transition"
              >
                Approve
              </button>
              <button
                onClick={() => updateRequestStatus(_id, 'rejected')}
                className="bg-red-600 text-white px-4 py-1 rounded hover:bg-red-700 transition"
              >
                Reject
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RedemptionRequests;
